import React, { useEffect, useState } from 'react';
import { Box, Container, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow,  } from '@mui/material';
import { ArrowDropUp, ArrowDropDown } from '@mui/icons-material';
import { toast } from 'react-toastify';
import ClassificationBannerHeader from '../common/banner/classifactionBannerHeader';
import PageHeader from '../common/banner/pageHeader';
import { sortAdminItems } from '../common/utils/tableUtil';
import SearchBar from '../common/search/SearchBar';

export const ExpirationDate = (date, format) => {
  const registration_date = new Date(date);
  const options = { timeZone: 'America/New_York', year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' };
  if (format) return new Intl.DateTimeFormat('en-US', options).format(registration_date.setDate(registration_date.getDate() + 45));
  return registration_date.setDate(registration_date.getDate() + 45);
}

const UserMetricsTable = ({ items, sortConfig, onSortChange}) => {
    const curr_date = new Date();
    const handleSort = (key) => {
        const direction = sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
        onSortChange({ key, direction });
    };

    const SortIcon = ({ field }) => {
        if (sortConfig.key !== field) return null;
            return sortConfig.direction === 'asc' ? 
            (<ArrowDropUp fontSize="small" />) : 
            (<ArrowDropDown fontSize="small" />);
    };

    const DaysExpiring = (date) => {      
      const expiration_date = new Date(ExpirationDate(date, false));
      const day = 1000*60*60*24;
      return Math.ceil((expiration_date.getTime() - curr_date.getTime())/day);
    }
    
    return (
    <>
      <TableContainer component={Paper} sx={{ mt: 4 }}>
        <Table sx={{ minWidth: 600 }} aria-label="simple table">    
          <TableHead>
            <TableRow sx={{ backgroundColor: '#0568AE' }}>
              {['User Name', 'First Name', 'Last Name', 'Email'].map((field) => (
                <TableCell
                  key={field}
                  onClick={() => handleSort(field)}
                  sx={{ color: '#EEEEEE', fontWeight: 'bold', cursor: 'pointer', userSelect: 'none' }}
                >
                  <Stack direction="row" alignItems="center" spacing={0.5}>
                    <span>{field.charAt(0).toUpperCase() + field.slice(1)}</span>
                    <SortIcon field={field} />
                  </Stack>
                </TableCell>                
              ))}
              <TableCell sx={{ color: '#EEEEEE', fontWeight: 'bold' }}>Phone Number</TableCell>
              <TableCell sx={{ color: '#EEEEEE', fontWeight: 'bold' }}>Expiration Date</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((item, index) => (
              <TableRow key={item.id} sx={{ height: 56, backgroundColor: DaysExpiring(item.registration_dt) < 0? '#c90606':
                                                                         DaysExpiring(item.registration_dt) <= 7? '#ac9a15':
                                                                         index % 2 === 0 ? '#2A2A2A' : '#000000' }}>   
                <TableCell sx={{ color: '#FFFFFF' }}>{item.username}</TableCell>
                <TableCell sx={{ color: '#FFFFFF' }}>{item.firstname}</TableCell>
                <TableCell sx={{ color: '#FFFFFF' }}>{item.lastname}</TableCell>
                <TableCell sx={{ color: '#FFFFFF' }}>{item.emailaddr}</TableCell>
                <TableCell sx={{ color: '#FFFFFF' }}>{item.phone}</TableCell>
                <TableCell sx={{ color: '#FFFFFF' }}>{ExpirationDate(item.registration_dt, true)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

export default function UserMetrics() {
    const [users, setUsers] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'asc' });
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    useEffect(() => {
        fetchUsers();
    }, []);

    const fetchUsers = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API}/users/metrics`);            
            if (!response.ok) {
                toast.error(`HTTP error! status: ${response.status}`);
            } else {
                const json = await response.json();
                setUsers(json.data);
            }
        } catch (error) {
            toast.error(error);
        } 
    };

    const handleSortChange = (newConfig) => {
        setSortConfig(newConfig);
    };

    const filtered = users.filter((item) => {
        const s = searchQuery.toLowerCase();
        return ['username', 'firstname', 'lastname', 'emailaddr', 'phone', 'registration_dt'].some((field) => item[field]?.toLowerCase().includes(s));
    });

  const sorted = sortAdminItems(filtered, sortConfig);
  const paginated = sorted.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <Container sx={{ minWidth:1800, mt: 10, mb: 10 }}>
        <Box sx={{pt: 2}}>
            <ClassificationBannerHeader />
            <PageHeader title="User Metrics" />
            <Stack direction="row" justifyContent="flex-end" mt={2} mb={1} sx={{ width: '100%', mx: 'auto' }}>                    
                  <SearchBar
                      value={searchQuery}
                      onChange={setSearchQuery}
                      placeholder="Search Users..."
                      label="Search Users..."
                      width={200}
                  />                
            </Stack>
          
            <TableContainer component={Paper} sx={{ mt: 4, backgroundColor: '#1A1A1A'  }}>
                <UserMetricsTable
                    items={paginated}
                    sortConfig={sortConfig}
                    onSortChange={handleSortChange}
                    fetchUsers={fetchUsers}
                    setUsers={setUsers}
                />
                <TablePagination
                    component="div"
                    count={sorted.length}
                    page={page}
                    onPageChange={(e, newPage) => setPage(newPage)}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={(e) => { setRowsPerPage(+e.target.value); setPage(0); }}
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    sx={{ color: 'white', '& .MuiSvgIcon-root': { color: 'white' } }}
                />
            </TableContainer>
        </Box>
    </Container>
  )
}
